import { render, staticRenderFns } from "./TieManagement.vue?vue&type=template&id=206d46ba&scoped=true&lang=pug"
import script from "./TieManagement.vue?vue&type=script&lang=js"
export * from "./TieManagement.vue?vue&type=script&lang=js"
import style0 from "./TieManagement.vue?vue&type=style&index=0&id=206d46ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d46ba",
  null
  
)

export default component.exports